import { getOutInList } from '@/api/carManage'
import selectOption from '@/store/dict/selectOptionDict'
import CARDICT from '@/store/dict/carDict.js'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

// 页面配置
export default function (data) {
  const dealWithSearch = (params) => {
    if (data.dealWithData) data.dealWithData(params)
    if (params.times && params.times.length) {
      params.createTimeStart = params.times[0]
      params.createTimeEnd = params.times[1]
    }
    return params
  }
  const configData = {
    formData: {
      formProps: {
        ref: 'searchForm',
      },
      list: [
        {
          el: 'select',
          itemConfig: {
            label: '客户名称',
            prop: 'customerId',
          },
          elConfig: {
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            filterable: true,
            remote: true,
            'reserve-keyword': true,
            clearable: true,
            placeholder: '请输入',
            'remote-method':
            (query) => {
              this.getCustomerList(query)
            },
            options: {
              label: 'customerName',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '出入库ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
        },
        {
          el: 'select',
          itemConfig: {
            label: '是否上传验车信息',
            prop: 'hasInspection',
          },
          elConfig: {
            options: { // 下拉数据
              label: 'label',
              value: 'value',
              list: [],
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '创建时间',
            prop: 'times',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '出入库类型',
            prop: 'type',
            ref: 'type',

          },
          elConfig: {
            options: { // 下拉数据
              label: 'label',
              value: 'value',
              list: [],
            },
          },
        },
      ],
      dealWithSearch, // 查询
    },
    // 表格
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '出入库ID',
            width: 140,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户名称',
          },
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '出入库状态',
            width: 120,
          },
          // eslint-disable-next-line no-nested-ternary
          getText: ({ row }) => (row.state === 0
            // eslint-disable-next-line no-nested-ternary
            ? (row.type === 1
              ? '待出库'
              : (row.type === 2 ? '待入库' : '--'))
            : selectOption.outInState[row.state]),
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '创建时间',
            width: 160,
          },
          type: 'date',
        },
        {
          name: 'type',
          columnProps: {
            prop: 'type',
            label: '出入库类型',
            width: 100,
          },
          getText: ({ row }) => CARDICT.OUT_INT_TYPE()[row.type],
        },
        {
          name: 'takeOverTime',
          columnProps: {
            prop: 'takeOverTime',
            label: '交接完成时间',
            width: 160,
          },
        },
        {
          name: 'hasInspection',
          columnProps: {
            prop: 'hasInspection',
            label: '是否上传验车信息',
            width: 160,
          },
          getText: ({ row }) => (row.hasInspection ? '是' : '否'),
          columnHeaderTooltip: '验车信息包含验车交接文件和车辆相关图片',
        },
      ],
      apiFn: getOutInList,
    },
  }
  return {
    configData,
  }
}
